import { useTranslation } from "react-i18next";
import AppButton from "../buttons/AppButton";
import type { ButtonSize, ButtonVariant } from "../styles/buttonStyles";
import { useCopyToClipboard } from "./useCopyToClipboard";

interface CopyButtonProps {
  /** The exact text copied. */
  value: string;
  /** The button's text, saying what is copied ("Copy link"). */
  children: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
}

/**
 * A labelled button that copies a longer value, such as a link shown beside it. For an ID or
 * hash in running text, use CopyReference; both report the outcome the same way.
 */
export default function CopyButton({ value, children, variant = "secondary", size = "xs" }: CopyButtonProps) {
  const { t } = useTranslation();
  const { status, copy } = useCopyToClipboard();
  const outcome = status === "idle" ? "" : t(`common.copyReference.${status}`);
  return (
    <>
      <AppButton variant={variant} size={size} onClick={() => { copy(value); }}>
        {outcome === "" ? children : outcome}
      </AppButton>
      <span className="sr-only" aria-live="polite">{outcome}</span>
    </>
  );
}
